
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/join-us/[id]",
      function () {
        return require("private-next-pages/join-us/[id]/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/join-us/[id]"])
      });
    }
  